<app-container-transparent>

    <h2>Cadastro de Consultor</h2>

    <div fxLayout="column">

        <div fxFlex="40">
            <form [formGroup]="formGroup" (ngSubmit)="submitForm()">
                <mat-form-field style="width: 100%" appearance="outline">
                    <mat-label>NOME</mat-label>
                    <input autocomplete="off" formControlName="nome"
                           matInput placeholder="NOME" required="true">
                </mat-form-field>

                <mat-form-field style="width: 100%" appearance="outline">
                    <mat-label>EMAIL</mat-label>
                    <input autocomplete="off" formControlName="email"
                           matInput placeholder="NOME" required="true">
                </mat-form-field>

                <mat-form-field style="width: 100%" appearance="outline">
                    <mat-label>CPF</mat-label>
                    <input autocomplete="off" formControlName="cpf"
                           matInput placeholder="NOME" required="true">
                </mat-form-field>

                <div>
                    <div fxFlex="90"></div>
                    <div fxFlex="5">
                        <button type="submit" class="action-steps-btn" [disabled]="false" mat-raised-button color="primary">
                            CRIAR
                        </button>
                    </div>
                </div>
            </form>
        </div>

        <div fxFlex="60">

        </div>

    </div>

</app-container-transparent>